<script setup>
import { useMessages } from '../../../composables/useMessages'
import Message from './Message.vue'

const { messages } = useMessages()
</script>

<template>
	<div class="min-h-[150px] flex flex-col fixed right-8 top-4 gap-4 items-end">
		<TransitionGroup name="alerts">
			<Message
				v-for="message in messages"
				:key="message.id"
				:title="message.title"
				:description="message.description"
				:actions="message.actions"
				:closeable="message.closeable"
				:type="message.type"
			/>
		</TransitionGroup>
	</div>
</template>

<style scoped>
.alerts-enter-active,
.alerts-leave-active {
	transition: all 0.5s ease;
}

.alerts-enter-from,
.alerts-leave-to {
	opacity: 0;
	transform: translateX(30px);
}
</style>
